import { LocationSvg } from "../../CustomSvg";
import { Button } from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { getRequest, postRequest } from "../../../../hooks/axiosClient";
import { environmentaldatas } from "../../../../constant/defaultValues";
import { getCurrentUser } from "../../../../helpers/utils";
import { setProjectData } from "../../../../store/slices/projectItemSlice";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { SetBackEndErrorsAPi } from "../../../../hooks/setBEerror";
import lock from '../../../../assets/img/lock.png';
import unlock from '../../../../assets/img/padlock-unlock.png';
import { useProjectHeader } from "../../Helpers/pageDiv/ProjectHeaderContext";
import EditProjectModal from "../../Helpers/pageDiv/editProjectNameModal";

const SAVE_STATUS_CONFIG = {
  saving: { label: "Saving…",       color: "var(--color-text-secondary)" },
  saved:  { label: "✓ Saved",       color: "var(--color-text-success)"   },
  failed: { label: "✗ Save failed", color: "var(--color-text-danger)"    },
};

const { image_url } = environmentaldatas;

const validationSchema = Yup.object().shape({
  project_name: Yup.string().required("This field is required."),
  is_pass_protected: Yup.boolean(),
  password: Yup.string().when("is_pass_protected", {
    is: true,
    then: (s) =>
      s.required("Password field is required.").min(6, "Minimum 6 characters"),
    otherwise: (s) => s.notRequired(),
  }),
  confirm_password: Yup.string().when("is_pass_protected", {
    is: true,
    then: (s) =>
      s
        .required("Confirm password is required.")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    otherwise: (s) => s.notRequired(),
  }),
});
 
const SaveChip = ({ status }) => {
  if (status === "idle") return null;
  const cfg = SAVE_STATUS_CONFIG[status];
  return (
    <span
      style={{
        display:    "inline-flex",
        alignItems: "center",
        gap:        5,
        fontSize:   12,
        fontWeight: 500,
        padding:    "3px 9px",
        borderRadius: 6,
        color:      cfg?.color,
        background: status === "saving" ? "transparent" : undefined,
      }}
    >
      {status === "saving" && (
        <span
          className="spinner-border spinner-border-sm"
          style={{ width: 9, height: 9, borderWidth: 1.5 }}
        />
      )}
      {cfg?.label}
    </span>
  );
};
 
const ProjectHeaderDiv = () => {
  const {
    projectSettings,
    projectSettingData,
    isPublish,
    isDiscard,
    isDirty,
    toggle,
    showpassfield,
    modal,
    onDiscardClick,
    onPublishClick,
    onExitClick,
    getProjectById,
    handleEnableDisable,
  } = useProjectHeader();

  const [loading, setLoading] = useState(false);
  const saveStatus = useSelector((s) => s.navigation.saveStatus);

  const handleSubmitProject = async (values, setFieldError) => {
    setLoading(true);
    const formdata = new FormData();
    const trimmedLogo = values?.logo?.replace(image_url, "") ?? "";

    const fields = [
      ["logo",                  trimmedLogo],
      ["customer_id",           values?.enc_customer_id ?? getCurrentUser()?.user?.common_id],
      ["project_name",          values?.project_name],
      ["background_color",      values?.background_color],
      ["fill_color",            values?.fill_color],
      ["border_thick",          values?.border_thick],
      ["border_color",          values?.border_color],
      ["inactive_color",        values?.inactive_color],
      ["location_color",        values?.location_color],
      ["product_color",         values?.product_color],
      ["start_color",           values?.start_color],
      ["beacon_color",          values?.beacon_color],
      ["amenity_color",         values?.amenity_color],
      ["safety_color",          values?.safety_color],
      ["level_change_color",    values?.level_change_color],
      ["navigation_color",      values?.navigation_color],
      ["is_pass_protected",     values?.is_pass_protected ? 1 : 0],
      ["pass_update",           values?.pass_update ? 1 : 0],
      ["error_reporting_email", values?.error_reporting_email ?? ""],
      ["navigation_thick",      values?.navigation_thick ?? "3"],
    ];

    fields.forEach(([key, val]) => formdata.append(key, val));

    if (values?.is_pass_protected && values?.pass_update) {
      formdata.append("password",         values?.password         ?? 0);
      formdata.append("confirm_password", values?.confirm_password ?? 0);
    }

    if (values?.enc_id) {
      [
        ["_method",      "PUT"],
        ["id",           values.enc_id],
        ["is_published", "0"],
        ["discard",      "1"],
        ["publish",      "1"],
      ].forEach(([k, v]) => formdata.append(k, v));
    }

    try {
      const url      = values?.enc_id ? `project/${values.enc_id}` : "project";
      const response = await postRequest(url, formdata, true);
      const data     = response.response?.data ?? [];
      if (response.type === 1) {
        getProjectById();
        handleEnableDisable();
        toggle();
        toast.success(data?.message);
      } else {
        SetBackEndErrorsAPi(response, setFieldError);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };
 
  const publishDisabled = (() => {
    if (projectSettingData?.status === 0) return true;
    if (isPublish === 1 || isDirty) return false;
    return isPublish !== 1;
  })();

  return (
    <>
      <div className="view-project-header">
        <div className="row align-items-center" style={{ margin: 0 }}>
 
          <div className="col-sm-6">
            <div className="header-lock-content" style={{ display: "flex", alignItems: "center", gap: 8 }}>
               
              <p
                onClick={() => toggle()}
                style={{
                  cursor:       "pointer",
                  marginLeft:   10,
                  marginBottom: 0,
                  color:        "#1D1D1B",
                  fontSize:     "0.9375rem",
                  fontWeight:   500,
                }}
              >
                {projectSettings?.project_name}
              </p>
 
              {projectSettings?.project_name && (
                <span
                  onClick={() => toggle("passprotect")}
                  style={{ cursor: "pointer", display: "inline-flex", lineHeight: 1 }}
                  title={projectSettings?.is_pass_protected ? "Password protected" : "No password"}
                >
                  {/* <LockIcon locked={projectSettings?.is_pass_protected} /> */}
                   <img
                        src={projectSettings?.is_pass_protected ? lock : unlock}
                    />
                </span>
              )}
            </div>
          </div>          
 
          <div className="col-sm-6 pr-0">
            <div
              className="button-position-end"
              style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "flex-end" }}
            >
              <SaveChip status={saveStatus} />

              <Button
                className={`btn-secondary btn-scndry ${isDiscard !== 0 ? "btn-disabled-discard" : ""}`}
                size="small"
                onClick={onDiscardClick}
                disabled={isDiscard !== 0 || saveStatus === "saving"}
              >
                Discard changes
              </Button>

              <Button
                className={`btn-primary bar-btn ${publishDisabled ? "btn-disabled-publish" : ""}`}
                size="medium"
                onClick={onPublishClick}
                disabled={publishDisabled  || saveStatus === "saving"}
              >
                Publish
              </Button>

              {/* <span className="vertical-line-pindiv" style={{ margin: "0 4px" }} /> */}

              <Button
                className="btn-secondary btn-scndry btn-xs exit-button"
                size="small"
                style={{ fontWeight: 400 }}
                disabled = { saveStatus === "saving"}
                onClick={onExitClick}
              >
                Save draft &amp; exit
              </Button>
            </div>
          </div>
        </div>
      </div>

      <EditProjectModal
        modal={modal}
        toggle={toggle}
        showpassfield={showpassfield}
        initialValues={projectSettingData}
        validationSchema={validationSchema}
        handleSubmitProject={handleSubmitProject}
        loading={loading}
      />
    </>
  );
};

export default ProjectHeaderDiv;